import React, { useState, useEffect } from 'react';
import { Form } from '@ant-design/compatible';
import '@ant-design/compatible/assets/index.css';
import {
  Button,
  Divider,
  Checkbox,
  Table,
  Select,
  TimePicker,
  Popconfirm,
} from 'antd';
import { weekdays } from 'moment';
import { useTranslation } from 'react-i18next';
import i18next from 'i18next';

const Option = Select.Option;
const FormItem = Form.Item;
const days = weekdays();

const TimelineTable = ({
  arrangedSelectedLocations,
  locations,
  allBusSalons,
  form: { getFieldDecorator, getFieldValue, setFieldsValue },
}) => {
  const [dynamicColumns, setDynamicColumns] = useState([]);
  const [t,i18n]=useTranslation();
  const nameLang = i18n.language;
  const [dataSource, setDataSource] = useState([
    {
      key: Date.now(),
    },
  ]);

  const deleteRow = (index) => {
    setFieldsValue({
      [`timeLines.create[${index}].bus_salon_id`]: undefined,
    });
    const filteredDataSource = dataSource.filter((el, i) => i !== index);
    setDataSource(filteredDataSource);
  };

  useEffect(() => {
    // TODO: refactor -- bad performance
    const selectedLocationObj = arrangedSelectedLocations
      .map((selectedCity) => {
        return selectedCity.locations.map((selectedLocation) => {
          return locations.find((location) => {
            return (
              nameLang === "en" ? selectedLocation === location.name_en &&
              location.city.name_en === selectedCity.city : selectedLocation === location.name_ar &&
              location.city.name_ar === selectedCity.city 
            );
          });
        });
      })
      .flat();
    const dynamicColumns = selectedLocationObj.map((location, locationIdx) => ({
     title: nameLang === "en" ? location.name_en : location.name_ar,
      render: (name, row, i) => {
        const inTwoDays = getFieldValue(`timeLines.create[${i}].inTwoDays`);
        const prevInTwoDays =
          locationIdx !== 0 &&
          getFieldValue(
            `timeLines.create[${i}].timeLineSlots.create[${
              locationIdx - 1
            }].inTwoDays`
          );
        const prevTiming =
          locationIdx !== 0 &&
          getFieldValue(
            `timeLines.create[${i}].timeLineSlots.create[${
              locationIdx - 1
            }].time`
          );
        const currentInTwoDays =
          inTwoDays &&
          getFieldValue(
            `timeLines.create[${i}].timeLineSlots.create[${locationIdx}].inTwoDays`
          );
        return (
          <>
            <FormItem>
              {getFieldDecorator(
                `timeLines.create[${i}].timeLineSlots.create[${locationIdx}].location_id`,
                {}
              )(<></>)}
            </FormItem>
            <FormItem>
              {getFieldDecorator(
                `timeLines.create[${i}].timeLineSlots.create[${locationIdx}].time`,
                {
                  rules: [
                    {
                      required: true,
                      message: 'This field is required!',
                    },
                    {
                      validator: (_, value, callback) => {
                        if (
                          prevTiming &&
                          !currentInTwoDays &&
                          prevTiming.valueOf() > value.valueOf()
                        ) {
                          callback(
                            'Arrival date cannot be after the departure date'
                          );
                        } else {
                          callback();
                        }
                      },
                    },
                  ],
                }
              )(
                <TimePicker
                placeholder={t("Select time")}
                  format={'HH:mm'}
                  onChange={() =>
                    setFieldsValue({
                      [`timeLines.create[${i}].timeLineSlots.create[${locationIdx}].location_id`]: location.id,
                    })
                  }
                />
              )}
            </FormItem>
            {inTwoDays && (
              <>
                <Divider type="horizontal" />
                <FormItem>
                  {getFieldDecorator(
                    `timeLines.create[${i}].timeLineSlots.create[${locationIdx}].inTwoDays`,
                    {
                      // Common Sense: if a trip is going from Alex to Cairo to Sohag
                      // and it arrives in Cairo on the next day
                      // it will be in Sohag also on the next day
                      initialValue: prevInTwoDays ? true : false,
                      valuePropName: 'checked',
                    }
                  )(
                    <Checkbox disabled={prevInTwoDays} value={true}>
                      {t("In Two Days")}
                    </Checkbox>
                  )}
                </FormItem>
              </>
            )}
          </>
        );
      },
    }));

    setDynamicColumns(dynamicColumns);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [arrangedSelectedLocations]);

  const columns = [
    {
      title: t('Bus Salon'),
      key: 'bus-salon',
      render: (name, row, i) => (
        <FormItem>
          {getFieldDecorator(`timeLines.create[${i}].bus_salon_id`, {
            rules: [
              {
                required: true,
                message: t('This field is required!'),
              },
            ],
          })(
            <Select style={{ width: 120 }}>
              {allBusSalons.map((option, idx) => (
                <Option key={idx} value={option.id}>
                  {option.name}
                </Option>
              ))}
            </Select>
          )}
        </FormItem>
      ),
    },
    {
      title: t('Day'),
      key: 'days',
      render: (name, row, i) => (
        <>
          <FormItem>
            {getFieldDecorator(`timeLines.create[${i}].days`, {
              rules: [
                {
                  required: true,
                  message: t('This field is required!'),
                },
              ],
            })(
              <Select mode="multiple" style={{ width: 120 }}>
                {days.map((option, idx) => (
                  <Option key={idx} value={option}>
                    {t(option)}
                  </Option>
                ))}
              </Select>
            )}
          </FormItem>
          <Divider type="horizontal" />
          <FormItem>
            {getFieldDecorator(`timeLines.create[${i}].inTwoDays`, {
              initialValue: false,
              valuePropName: 'checked',
            })(<Checkbox value={true}>{t("In Two Days")}</Checkbox>)}
          </FormItem>
        </>
      ),
    },
    ...dynamicColumns,
    {
      title: t('Action'),
      dataIndex: '',
      key: 'x',
      render: (text, record, i) => {
        return dataSource.length > 1 && i === dataSource.length - 1 ? (
          <Popconfirm title={t("Sure to delete?")} onConfirm={() => deleteRow(i)}>
            <button>{t("Delete")}</button>
          </Popconfirm>
        ) : (
          <></>
        );
      },
    },
  ];

  return (
    <>
      <Button
        style={{ marginTop: '30px', marginBottom: '30px' }}
        onClick={() =>
          setDataSource([
            ...dataSource,
            {
              key: Date.now(),
            },
          ])
        }
        type="primary"
      >
        {t("Add a row")}
      </Button>
      <Table
        bordered
        dataSource={dataSource}
        columns={columns}
        scroll={{ x: true }}
      />
    </>
  );
};

const WrappedTimelineTable = Form.create({
  onValuesChange(props, _, values) {
    const { allBusSalons, setSelectedBusSalons } = props;
    const {
      timeLines: { create: timeLinesArray },
    } = values;
    const busSalons = [];
    const busSalonsIds = timeLinesArray
      .filter((tl) => tl.bus_salon_id !== undefined)
      .map((tl) => tl.bus_salon_id);
    busSalonsIds.forEach((busSalonId) => {
      const busSalon = allBusSalons.find(
        (busSalon) => busSalon.id === busSalonId
      );
      busSalons.push(busSalon);
    });
    setSelectedBusSalons(busSalons);
  },
})(TimelineTable);
export default WrappedTimelineTable;
